import { Component } from "react";
import { NSARouterMakerResult } from "namirasoft-account-react";
import { InfraLayout } from '../InfraLayout';
import { InfraEntities } from "../InfraEntities";
import { InfraRouterProps } from "../InfraRouterProps";
import ProjectDiagram from "../components/ProjectDiagram";
import { NSSpace, NSSpaceSizeType } from "namirasoft-site-react";

interface EnvironmentViewPageProps extends NSARouterMakerResult, InfraRouterProps { }

export default class EnvironmentViewPage extends Component<EnvironmentViewPageProps>
{
    override render()
    {
        return (
            <InfraLayout
                {...this.props}
                pages={{
                    entity: InfraEntities.environment(this.props),
                    view: {
                        ui: {
                            getChildrenAfter: (id, row) => (
                                <>
                                    <NSSpace size={NSSpaceSizeType.MINI} />
                                    <ProjectDiagram
                                        {...this.props}
                                        project_id={row.project_id}
                                        environment_id={id}
                                    />
                                </>
                            )
                        }
                    }
                }}
            >
                <></>
            </InfraLayout>
        );
    }
}